import { Truck, Flame, Route, Layers, TrendingUp, Sprout } from "lucide-react";

const pressures = [
  { icon: Truck, label: "Rising freight & fuel costs" },
  { icon: Flame, label: "Climate disruption & extreme weather" },
  { icon: Route, label: "Fragile transport infrastructure" },
  { icon: Layers, label: "Supply chain concentration" },
  { icon: TrendingUp, label: "Increasing food costs" },
  { icon: Sprout, label: "Reduced local production capability" },
];

export default function ShockRisk() {
  return (
    <section
      data-testid="shock-risk-section"
      className="relative bg-stone-alt py-24 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 items-end mb-14 md:mb-20">
          <div className="md:col-span-7">
            <div className="text-xs uppercase tracking-[0.3em] text-rust mb-6">
              Current Pressures
            </div>
            <h2
              data-testid="shock-risk-heading"
              className="font-serif text-4xl md:text-5xl lg:text-6xl font-light leading-[1.05] tracking-tight text-charcoal"
            >
              The remote food system
              <span className="block italic text-rust">shock risk.</span>
            </h2>
          </div>
          <div className="md:col-span-5">
            <p className="text-base md:text-lg leading-relaxed text-ink">
              Remote Australia faces compounding pressures that deepen each
              year. Growing Country has been designed to strengthen resilience
              <em> before</em> these pressures deepen further.
            </p>
          </div>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-px bg-stone-line border border-stone-line">
          {pressures.map((p, i) => {
            const Icon = p.icon;
            return (
              <div
                key={p.label}
                data-testid={`pressure-${i}`}
                className="bg-sand p-8 md:p-10 flex items-start gap-5 hover:bg-charcoal hover:text-sand transition-colors duration-500 group"
              >
                <div className="shrink-0 mt-1 text-rust group-hover:text-ochre transition-colors">
                  <Icon strokeWidth={1.5} className="w-6 h-6" />
                </div>
                <div>
                  <div className="text-[10px] uppercase tracking-[0.3em] text-ink/60 group-hover:text-sand/60 mb-2 transition-colors tick-num">
                    {String(i + 1).padStart(2, "0")}
                  </div>
                  <h3 className="font-serif text-2xl leading-snug">
                    {p.label}
                  </h3>
                </div>
              </div>
            );
          })}
        </div>

        <div className="mt-16 border-l-2 border-rust pl-6 max-w-3xl">
          <p className="font-serif text-2xl md:text-3xl text-charcoal italic leading-snug">
            Under normal conditions, centralised supply chains are efficient.
            <span className="block mt-2 text-rust">
              Under disruption, they become fragile.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
}
